import React from "react";
import Media from "react-media";
import { Image, Button } from "react-bootstrap";
import { IconBoxEventButtonComponent } from "../../../reusableComponents/IconBoxReusable/IconBoxReusableComponent";

const ExpDashboardIcons = ({ page, data, history, exp }) => {
    return (
        <React.Fragment>
            <div className="d-flex justify-content-start align-items-center w-100 pl-0">
                {/* <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 seating-left-side-navigation"> */}
                    {/* <div className="row"> */}
                        {data.map(ele =>
                            <div key ={ele?.link} className="col col-sm-2 col-md-2 col-lg-2 col-xl-2 text-center pl-0">
                                <IconBoxEventButtonComponent
                                    classSection={
                                        page === ele.code
                                            ? "newseating-dashboard-reusable-button newseating-dashboard-reusable-button-active"
                                            : "newseating-dashboard-reusable-button"
                                    }
                                    imageStyle="inside-image-button"
                                    src={ele.icon}
                                    iconText={ele.name}
                                    iconTextStyle={
                                        page === ele.code
                                            ? "icon-bottom-text icon-bottom-text-active"
                                            : "icon-bottom-text"
                                    }
                                    onClick={() => history.push(`${ele.link}`, exp?._id ? { id: exp._id, name: exp.name, expId: exp.expId } : {})}
                                    bedgeClass={`badge custom-icon-button-badge ${ele.name === 'Pending' ? "custom-badge-position-pending" : "custom-badge-position-reservation"}`}
                                    displayNotification={ele.showNotification}
                                    notificationCount={ele.count}
                                    bottomLine={page === ele.code ? "bottom-box-line" : null}
                                />
                            </div>
                        )}
                    {/* </div> */}
                    
                {/* </div> */}
                {/* {(history?.location?.pathname === "/specialDashboard" || history?.location?.pathname === "/curatedDashboard" ) ? (
                    <>
                      <div className="col-12 col-lg-4 col-xl-4 d-flex justify-content-end align-items-end">
                        <Button
                            variant="link"
                            className="mr-3 f12-500 text-blue"
                            onClick={()=>{history.push({
                                pathname:'/expiredexperiencesDashboard',
                                state:{exptype:history?.location?.pathname},
                             })}}
                          >
                            
                                  View Expired Experiences
                              
                          </Button>
                
                </div>
                    </>
                ) : null} */}
              
            </div>
        
        </React.Fragment>
    );
};

export default ExpDashboardIcons;
